// src/components/Auth/SubscriptionRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSubscription } from '../../contexts/SubscriptionContext';

const SubscriptionRoute = ({ requiredPlan, children }) => {
  const { user, isAuthenticated } = useAuth();
  const { subscription, loading } = useSubscription();
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // If subscription data is loading, show a loading state
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Plan hierarchy: free < standard < premium < family < business
  // Each tier inherits access to all routes for lower tiers.
  const PLAN_RANK = { free: 0, standard: 1, premium: 2, family: 3, business: 4 };

  const hasRequiredPlan = () => {
    const userRank = PLAN_RANK[subscription?.plan] ?? 0;
    const requiredRank = PLAN_RANK[requiredPlan] ?? 0;
    return userRank >= requiredRank;
  };
  
  // If user doesn't have required plan, redirect to plans page
  if (!hasRequiredPlan()) {
    return <Navigate to="/subscription/plans" />;
  }
  
  // User has required plan, render the protected component
  return children;
};

export default SubscriptionRoute;